@if (mock) {
  <div class="bg-n-1000 h-[43px] relative z-50"></div>
} @else {
  <div id="global-header"></div>
}
